// import React, { useEffect, useRef } from "react";
// import { gsap } from "gsap";
// import ServicesSection from "./Services";
// import AIPoweredSection from "./AI-PoweredFeatures";
// import OurProduct from "./OurProduct";
// import ProblemThatAim from "./ProblemThatAim";
// import AboutSection from "./About";

// const statCards = [
//   { title: "500+", subtitle: "Jobs Posted" },
//   { title: "120+", subtitle: "Companies" },
//   { title: "5k+", subtitle: "Applicants" },
// ];

// export default function Home() {
//   const heroRef = useRef();
//   const textCircleRef = useRef();

//   useEffect(() => {
//     // Hero Section Animations
//     const ctx = gsap.context(() => {
//       const tl = gsap.timeline();

//       tl.from(".nav", { y: -50, opacity: 0, duration: 0.8 })
//         .from(".hero-title", { y: 50, opacity: 0, duration: 0.8 })
//         .from(".hero-desc", { y: 30, opacity: 0, duration: 0.8 })
//         .from(".hero-stats > div", {
//           y: 20,
//           opacity: 0,
//           duration: 0.6,
//           stagger: 0.2,
//         })
//         .from(".hero-employers > img", {
//           y: 20,
//           opacity: 0,
//           duration: 0.6,
//           stagger: 0.2,
//         })
//         .from(".hero-card", { scale: 0.8, opacity: 0, duration: 0.8 });
//     }, heroRef);

//     // Circular Text Rotation Animation
//     gsap.to(textCircleRef.current, {
//       rotation: 360,
//       duration: 10,
//       repeat: -1,
//       ease: "linear",
//       transformOrigin: "center center",
//     });

//     return () => ctx.revert();
//   }, []);


//   const sectionRef = useRef(null);

//   useEffect(() => {
//     const ctx = gsap.context(() => {
//       gsap.from(".fade-in", {
//         opacity: 0,
//         y: 50,
//         duration: 1.2,
//         ease: "power3.out",
//         stagger: 0.3,
//         scrollTrigger: {
//           trigger: sectionRef.current,
//           start: "top 85%",
//         },
//       });

//       gsap.from(".scale-in", {
//         opacity: 0,
//         scale: 0.8,
//         duration: 1.5,
//         ease: "elastic.out(1, 0.7)",
//         stagger: 0.3,
//         scrollTrigger: {
//           trigger: sectionRef.current,
//           start: "top 80%",
//         },
//       });
//     }, sectionRef);

//     return () => ctx.revert();
//   }, []);

//   return (
//     <>




//       {/* <HeroSection /> */}

//       {/* ====== SECTION 2: EXPLORE JOBS ====== */}
//       <AboutSection />

//       {/* ====== SECTION 3: EXPLORE JOBS ====== */}
//       <OurProduct />


//       {/* ====== SECTION 4: EXPLORE JOBS ====== */}
//       <ProblemThatAim />



//       {/* ====== SECTION 5: SERVICES SECTION ====== */}
//       <ServicesSection />

//       {/* ====== SECTION 6: AI-Powered ====== */}
//       <AIPoweredSection />


//       {/* ====== FOOTER ====== */}
//       {/* <section className="mt-16 bg-gradient-to-r from-indigo-900 via-purple-800 to-indigo-700 text-white py-20 px-6 text-center rounded-t-[60px]">
//         <div className="max-w-3xl mx-auto">
//           <h2 className="text-3xl md:text-4xl font-semibold mb-4">
//             Millions of jobs.
//           </h2>
//           <p className="text-lg md:text-xl mb-8">
//             Find the one that’s <span className="text-pink-400 font-bold">right for you.</span>
//           </p>

//         </div>
//       </section> */}

//             {/* <FooterSection /> */}

//     </>
//   );
// }


import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ServicesSection from "../Pages/Services";
import OurProduct from "../Pages/OurProduct";
import ProblemThatAim from "../Pages/ProblemThatAim";
import AboutSection from "../Pages/About";
import AIPoweredSection from "../Pages/AI-PoweredFeatures";
import HeroSection from "../Pages/Hero";
import FooterSection from "../Layout/Footer";
import ContactUs from "../Pages/ContactUs";
// import HeroSection from "./Hero";

gsap.registerPlugin(ScrollTrigger);

export default function Home() {
  const heroRef = useRef();
  const textCircleRef = useRef();
  const sectionRef = useRef(null);
  const cursorRef = useRef(null);


  // Cursor movement animation
  useEffect(() => {
    const cursor = cursorRef.current;
    const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    const mouse = { x: pos.x, y: pos.y };
    const speed = 0.2;

    const xSet = gsap.quickSetter(cursor, "x", "px");
    const ySet = gsap.quickSetter(cursor, "y", "px");

    window.addEventListener("mousemove", (e) => {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
    });

    gsap.ticker.add(() => {
      pos.x += (mouse.x - pos.x) * speed;
      pos.y += (mouse.y - pos.y) * speed;
      xSet(pos.x);
      ySet(pos.y);
    });

    // Hover scaling on interactive elements
    const links = document.querySelectorAll("a, button, .cursor-hover");
    links.forEach((el) => {
      el.addEventListener("mouseenter", () => {
        gsap.to(cursor, { scale: 2.5, backgroundColor: "#F26A33", duration: 0.3 });
      });
      el.addEventListener("mouseleave", () => {
        gsap.to(cursor, { scale: 1, backgroundColor: "#ffffff", duration: 0.3 });
      });
    });

    return () => {
      gsap.ticker.remove(() => { });
      window.removeEventListener("mousemove", () => { });
    };
  }, []);

  // Hero section animation
  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline();

      tl.from(".nav", { y: -50, opacity: 0, duration: 0.8 })
        .from(".hero-title", { y: 50, opacity: 0, duration: 0.8 })
        .from(".hero-desc", { y: 30, opacity: 0, duration: 0.8 })
        .from(".hero-stats > div", {
          y: 20,
          opacity: 0,
          duration: 0.6,
          stagger: 0.2,
        });
    }, heroRef);

    gsap.to(textCircleRef.current, {
      rotation: 360,
      duration: 10,
      repeat: -1,
      ease: "linear",
      transformOrigin: "center center",
    });

    return () => ctx.revert();
  }, []);

  // Scroll animations
  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(".fade-in", {
        opacity: 0,
        y: 50,
        duration: 1.2,
        ease: "power3.out",
        stagger: 0.3,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 85%",
        },
      });

      gsap.from(".scale-in", {
        opacity: 0,
        scale: 0.8,
        duration: 1.5,
        ease: "elastic.out(1, 0.7)",
        stagger: 0.3,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 80%",
        },
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <div ref={sectionRef} className="overflow-hidden">

      {/* Custom Mouse Cursor */}
      <div
        ref={cursorRef}
        className="fixed top-0 left-0 w-3 h-3 bg-white rounded-full pointer-events-none mix-blend-difference z-[9999] hidden md:block"
        style={{ transform: "translate(-50%, -50%)" }}
      ></div>

      {/* ====== HERO SECTION ====== */}
      <HeroSection />

      {/* ====== SECTION 5: AI-POWERED FEATURES ====== */}
      <AIPoweredSection />


      {/* ====== SECTION 1: ABOUT ====== */}
      <AboutSection />

      {/* ====== SECTION 2: OUR PRODUCT ====== */}
      <OurProduct />

      {/* ====== SECTION 3: PROBLEM THAT AIM TO SOLVE ====== */}
      <ProblemThatAim />

      {/* ====== SECTION 4: SERVICES ====== */}
      <ServicesSection />



      {/* ====== SECTION 6: CONTACT US ====== */}
      <ContactUs />

      {/* ====== FOOTER ====== */}
      <FooterSection />

    </div>
  );
}

